import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormBuilder, ReactiveFormsModule, Validators, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { LbnContainerComponent, LbnInputFieldComponent } from '../../shared/components';

@Component({
  selector: 'app-monthly-billing',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    LbnContainerComponent,
    LbnInputFieldComponent
  ],
  templateUrl: './monthly-billing.component.html',
  styleUrls: ['./monthly-billing.component.scss']
})
export class MonthlyBillingComponent {
     // @Input() title!: string;
  //@Input() subTitle!: string;
  loginForm: FormGroup;
  isLoading = false;

  constructor(private fb: FormBuilder) {
    // initialize form in constructor to avoid using injected service before initialization
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  title!: "Monthly Billing";
   subTitle!: "Form to manage monthly billing";
  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    // handle submit...
    setTimeout(() => (this.isLoading = false), 800);
  }
}